<template>
	
	<el-container class="container" ref="homePage">
	  <el-header class="header" style="height: 70px;">
	    <div class="logo_container">
	      <a href="http://www.jinshisoft.com/" target="_blank"><img :src="logo" class="logo" /></a>
	    </div>
	    <div class="top_menu">
	      {{AppName}}
	    </div>
			<div class="tianqi">
				<!-- <iframe width="100%" frameborder="0" scrolling="no" hspace="0" src="https://i.tianqi.com/?c=code&a=getcode&id=35&h=55&w=200"></iframe> -->
			  <iframe width="210" scrolling="no" height="60" frameborder="0" allowtransparency="true" src="https://i.tianqi.com?c=code&id=12&color=%23333333&icon=1&num=1&site=12"></iframe>
			</div>
	  </el-header>
	  <el-container class="main">
	    
	    <el-main class="content-container" ref="main">
	      <div class="container2">
					<!-- <div class="search">
						<el-input placeholder="请输入要搜索的内容" v-model="keyWord" class="input-with-select" @keyup.enter.native="Search" >
						    <el-button slot="append" icon="el-icon-search" @click="Search"></el-button>
						  </el-input>
					</div> -->
					<div style="padding: 0px; text-align: left; font-size: 16px;">
						<span v-if="keyWord">
							<template v-if="leixing=='带视频'">
								查找包含“<span style="color: red;">{{keyWord}}</span>”<b>{{leixing}}</b>的文档，找到 <span style="color: #000080;">{{data.length}}</span> 篇文档
							</template>
							<template v-else>
								查找包含“<span style="color: red;">{{keyWord}}</span>”的文档，找到 <span style="color: #000080;">{{data.length}}</span> 篇文档
							</template>
							
						</span>
						<span v-else-if="leixing=='带视频'">
							查找“<span style="color: red;">{{leixing}}</span>”的文档，找到 <span style="color: #000080;">{{data.length}}</span> 篇文档
						</span>
					</div>
					<div class="wendang" v-for="(item, index) in data" @click="go(item)">
						<div class="title" v-html="item.标题"></div>
						<div class="content" v-html="item.内容"></div>
					</div>
				</div>
	    </el-main>
	  </el-container>
	</el-container>
</template>

<script>
	import * as util from '@/utils/util.js';
	import { mapState } from 'vuex';
	
	
	export default {
	  data() {
	    return {
	      redirect: '',
				data:[],
				muluList: [],
				currentKey: '',
				emptyText: '',
				expandedKeys: ['0'],
				AppName: '帮助文档',
				logo: require('../assets/czylogo.png'),
				AppID: '',
				keyWord: '',
				leixing: '',
				videoImg: require('../assets/camera.png'),
				
	    }
	  },
		created() {
	    let that = this;
	    //console.log('lang:' + localStorage.lang)
			this.AppID=this.$route.params.appid;
			this.keyWord=this.$route.params.keyword;
			this.leixing=this.$route.params.leixing;
			
	    let userinfo=util.GetUserInfo();  //获取当前登录用户信息
			
			this.data=[];
	    //console.log(`当前用户：${userinfo.logname}`);
			console.log('this.$route.params', this.$route.params);
			
			this.SearchHelpWenDang(this.AppID, this.keyWord, this.leixing);
	  },
	  mounted(){
	  	/*
	    this.$nextTick(() => {
				
				// 禁用鼠标右键菜单
				document.addEventListener('contextmenu', function(e) {
						e.preventDefault();
						return false;
				});
				
				// 禁用键盘按键（F12 及常见开发者工具快捷键）
				document.addEventListener('keydown', function(e) {
					// 禁用 F12
					if (e.key === 'F12' || e.keyCode === 123) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+Shift+I (开发者工具)
					if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+Shift+J (控制台)
					if (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j')) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+Shift+C (元素选择器)
					if (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'c')) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+U (查看源代码)
					if (e.ctrlKey && (e.key === 'U' || e.key === 'u')) {
							e.preventDefault();
							return false;
					}
				});
				//屏蔽复制
				document.oncopy = function (event) {
					if (window.event) {
						event = window.event;
					} 
					try {
						var the = event.srcElement;
						if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA"))
						{
							return false;
						}
						return true;
					} catch (e) {
						return false;
					}
				}
				//屏蔽选中
				document.onselectstart = function (event) {
					if (window.event) {
						event = window.event;
					}
					try {
							var the = event.srcElement;
							if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA")) {
								return false;
							}
							return true;
					}
					catch (e) {
						return false;
					}
				}
	    });
			*/
	  },
	  methods: {
			SearchHelpWenDang(AppID, keyword, leixing){
				let loading = this.$loading({
					lock: true,
					text: '正在查询文档......',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.3)'
				});
				
				let url="/Handler/Help.ashx?mode=SearchHelpWenDang";
				this.$ajax.post(url,{AppID: AppID, keyword: keyword, leixing: leixing}).then((response)=>{
				  //console.log(response.data);
				  //console.log(JSON.stringify(response.data));
					if(loading){
						loading.close();
					}
				  let errorCode=response.data.errorCode;
				  if(errorCode=='0')
				  {
				    for(let item of response.data.data){
							if(this.keyWord){
								item.标题=item.标题.replaceAll(this.keyWord, '<span style="color: red;">' + this.keyWord + '</span>');
								item.内容=item.内容.replaceAll(this.keyWord, '<span style="color: red;">' + this.keyWord + '</span>');
								
							}
							if(item.带视频=='1'){
								item.标题 += '<span style="margin-left: 5px;"><img src="' + this.videoImg + '" height="18"></span>';
							}
							
						}
				    this.data = response.data.data;
				    
						//console.log(this.muluList);
				  }
				  
				}).catch((e)=>{
					if(loading){
						loading.close();
					}
				});
				
			},
			go(data){
				if(data.标题){
					//this.$router.push({path: '/view/' + data.UUID});
					window.open('/view/' + data.UUID, 'main');
				}
			},
			Search(){
				console.log('this.keyWord', this.keyWord, this.leixing);
				
				if(this.keyWord || this.leixing=='带视频'){
					
					this.SearchHelpWenDang(this.AppID, this.keyWord, this.leixing)
				}
			}
	  }
	}
</script>

<style lang="scss" scoped="scoped">
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		height: 100%;
		border: 0px solid #F00;
		overflow-y: auto;
		.header {
			padding: 0;
			height: 70px;
			line-height: 70px;
			// background-color: #3389e0;
			background-color: #43b6c8;
			background-color: #ffffff;
			border-bottom: 1px solid #377a84;
			border-bottom: 3px solid #eeeeee;
			color: #666666;
			font-size: 25px;
			text-align: left;
			.logo_container {
				float: left;
				border: 0px solid #FF0000;
				width: 150px;
				// background-color: #1271d0;
				// background-color: #377a84;
				text-align: center;
				.logo {
					margin: 0 auto;
					width: 100px;
					border: 0px solid #FF0000;
					vertical-align: middle;
	
				}
				
			}
			.title{
				font-family: 微软雅黑;
				float: left;
				font-size: 24px;
				padding-left: 20px;
				border: 0px solid #F00;
				letter-spacing: 5px;
			}
			.top_menu {
			  float: left;
			  border: 0px solid #FF6600;
				padding-left: 20px;
			  height: 70px;
			  
			}
			.tianqi{
				float: right;
			  margin-top: 5px;
			  width: 210px;
			  height: 60px;
			  overflow: hidden;
			}
		}
		.main {
			padding-left: 0;
			// display: flex;
			position: relative;
			// top: 0px;
			// bottom: 0px;
			width: 100%;
			.menu-container {
				//padding: 10px;
				// flex: 0 0 200px;
				width: 120px;
				//background-color: #333c4b;
				background-color: #344772;
				background-color: #424256;
				background-color: #f1f4f8;
				text-align: left;
				overflow-x: hidden;
				overflow-y: auto;
				border-right: 1px solid #DDDDDD;
				
			}
			.menu-collapsed{
				flex:0 0 50px;
				width: 50px;
			}
			.menu-expanded{
				flex:0 0 350px;
				width: 350px;
				padding-top: 0px;
			}
			.content-container {
				padding: 0;
				padding-top: 0px;
				flex: 1;
				height: 100%;
				overflow-y: auto;
				background-color: #F7F8F9;
				background-color: #FFFFFF;
				position: relative;
				text-align: left;
				.container2{
					margin: 0 auto;
					padding: 10px;
					width: 1000px;
					text-align: left;
				}
			}
		}
	}
.title{
	line-height: 50px;
	font-size: 20px;
}
.main {
	margin: 0 auto;
	width: 1000px;
	padding: 30px 0px;
	font-size: 25px;
  border: 0px solid #F0C78A;
}
.custom-tree-node {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 16px;
	padding-right: 8px;
	position: relative;
}
.line{
	text-align: right;
	&::before{
		content: ' ';
		width: 78%;
		border-bottom: 1px dashed #cccccc;
		position: absolute;
		top: 50%;
		right: 130px;
	}
}
.mulu{
	color: #000000;
	font-weight: bold;
	img{
		border: 0 solid #FFFFFF;
	}
}
.wendang{
	margin: 10px 0;
	padding: 15px 10px;
	font-size: 16px;
	border-bottom: 1px solid #EEEEEE;
	background-color: #F5F8Fb;
	.title{
		font-size: 22px;
		font-weight: bold;
		&:hover{
			cursor: pointer;
			text-decoration: underline;
		}
	}
	.content{
		font-size: 16px;
		line-height: 200%;
		text-indent: 32px;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		&:hover{
			cursor: pointer;
			text-decoration: underline;
		}
	}
}
.search{
	margin: 10px auto;
	width: 600px;
}
</style>